<template>
  <el-row class="search">
    <el-col>
      <el-form class="search__group" @submit.prevent.native="onSubmit">
        <el-input v-model="searchModel" @input.native="onChange" :class="inputClass" :placeholder="$t('search.placeholder')">
          <el-select v-model="selectModel" slot="append">
            <el-option
              v-for="item in search.selectItems"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-input>

        <el-button
          type="primary"
          native-type="submit"
          class="search__button"
          plain
        >
          {{$t('search.button')}}
        </el-button>
      </el-form>
    </el-col>
  </el-row>
</template>

<script>
/*
  feed search component
  use i18n locale
  see http://kazupon.github.io/vue-i18n/started.html for details
*/

export default {
  name: "AppSearch",
  data() {
    return {
      error: false
    };
  },
  props: {
    search: {
      type: Object,
      required: true
    }
  },
  computed: {
    searchModel: {
      get () {
        return this.search.input;
      },
      set (value) {
        this.$emit("onSearch", value);
      },
    },
    selectModel: {
      get () {
        return this.search.select;
      },
      set (value) {
        this.$emit("onSelect", value);
      },
    },
    inputClass() {
      this.error && this.$emit("onSearch", " ");
      return this.error ? "input-with-select input-with-select--error" : "input-with-select";
    }
  },
  methods: {
    onSubmit() {
      if(this.search.input.length) {
        this.error = false;
        this.$emit('onSubmit');
      } else {
        this.error = true;
      }
    },
    onChange(event) {
      this.error = false;
      if (!event.target.value.length) {
        this.$emit('onClear');
      }
    }
  }
}
</script>

<style>
  .search {
    margin-bottom: 50px;
  }

  .search__group {
    display: flex;
    align-items: center;
  }

  .el-input-group {
    width: 875px;
    flex-grow: 1;
  }



  .el-select .el-input {
    width: 165px;
  }

  .input-with-select {
    margin-right: 20px;
  }

  .input-with-select .el-input-group__append {
    background-color: #fff;
  }

  .search__button {
    width: 204px;
    font-family: "Roboto", "Arial", sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
  }

  .input-with-select--error::after {
    display: block;
    position: absolute;
    left: 0;
    bottom: -20px;
    font-family: "Roboto", "Arial", sans-serif;
    font-size: 14px;
    line-height: normal;
    color: rgba(173, 181, 197, 0.7);
    content: "Необходимо ввести строку в поле поиска";
  }

  @media screen and (max-width: 480px) {
    .search__group {
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
    .el-input-group {
      width: 100%;
      margin-bottom: 10px;
      margin-left: 15px;
    }
    .search__button {
      width: 100%;
    }
    .search {
      margin-bottom: 20px;
    }
  }
</style>
